import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/data-connector/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import CustomLoader from '../common/CustomLoader';
import CustomSelect from '../home/collections/CustomSelect';
import ParentContentCard from '../common/ParentContentCard';
import { dropdownsForSource } from '../../common/utils/data_source-util';
import { convertFields, getFieldDataTypeValue } from './common/common_utils';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import CustomRadio from '../../common/ui/CustomRadio';
import AlertMessageBox from '../../common/ui/AlertMessageBox';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';

export class DirectusCollectionsCreate extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    selectedCollectionIndex: 0,
    fieldDatatypes: [],
    directusCollection: '',
    selectedPrimaryKey: 'id',
  };
  async componentDidMount() {
    const { match, actions } = this.props;
    if (this.props.location.state) {
      const { collectionIndex } = this.props.location.state;
      this.setState({ selectedCollectionIndex: collectionIndex });
    }
    const { externalDbUuid, projectId, version } = match.params;
    const { selectedCollectionIndex } = this.state;
    await actions.loadExternalDatabaseForDirectus({ projectId, externalDbUuid, version });
    const { externalDbDirectus } = this.props.dataConnector;
    if (externalDbDirectus) {
      const allColname = externalDbDirectus ? externalDbDirectus.completeData.tables : null;
      const collectionName = allColname[selectedCollectionIndex];
      await actions.getSchemaForDirectusCollection({
        projectId,
        externalDbUuid,
        version,
        collectionName: collectionName.name,
        setting: externalDbDirectus.setting,
      });
      await actions.loadExternalDatabaseForDirectus({ projectId, externalDbUuid, version });
      this.setState({ directusCollection: this.props.dataConnector.externalDbDirectus });
    }
  }
  async componentDidUpdate(prevProps, prevState) {
    const { selectedCollectionIndex } = this.state;
    const { match } = this.props;
    const { projectId, externalDbUuid, version } = match.params;

    if (prevState.selectedCollectionIndex !== selectedCollectionIndex) {
      const { externalDbDirectus } = this.props.dataConnector;
      if (externalDbDirectus) {
        const allColname = externalDbDirectus.completeData.tables;
        const collectionName = allColname[selectedCollectionIndex].name;
        await this.props.actions.getSchemaForDirectusCollection({
          projectId,
          externalDbUuid,
          version,
          collectionName,
          setting: externalDbDirectus.setting,
        });
        await this.props.actions.loadExternalDatabaseForDirectus({
          projectId,
          externalDbUuid,
          version,
        });

        this.setState({
          directusCollection: this.props.dataConnector.externalDbDirectus,
        });
      }
    }
  }
  checkCollectionIndex = (state) => {
    if (state) {
      if (state.collectionIndex >= 0) {
        return true;
      }
    }
    return false;
  };
  handleCollection = () => {
    const { match, location } = this.props;
    const { projectId, externalDbUuid, version } = match.params;
    if (this.checkCollectionIndex(location.state)) {
      this.props.history.push(
        `/2.0/data-connector/${version}/v/${projectId}/directus-edit/${externalDbUuid}`,
      );
    } else {
      const { selectedCollectionIndex, directusCollection } = this.state;
      const newArray = directusCollection.completeData['tables'];
      const totalLengh = newArray.length - 1;
      if (selectedCollectionIndex < totalLengh) {
        this.setState({ selectedCollectionIndex: selectedCollectionIndex + 1 });
      } else {
        this.props.history.push(`/2.0/collections/${version}/v/${projectId}`);
      }
    }
  };

  handleSave = async (values) => {
    const { selectedCollectionIndex, fieldDatatypes, directusCollection, selectedPrimaryKey } =
      this.state;
    const { actions, match } = this.props;
    const { completeData, setting, name } = directusCollection;
    const newArray = completeData['tables'];
    const selectedData = newArray[selectedCollectionIndex];
    const fieldData = selectedData.fields;
    const result = {};
    Object.keys(fieldData).map((fieldName, index) => {
      result[fieldName] = fieldDatatypes[fieldName]
        ? fieldDatatypes[fieldName].value
        : fieldData[fieldName];
    });
    const newResult = convertFields(result);
    const { projectId, externalDbUuid, version } = match.params;
    const data = {
      version,
      collectionTitle: values.collectionTitle,
      orgCollectionName: selectedData.name,
      collectionName: selectedData.name,
      willPersist: false,
      fields: newResult,
      projectId,
      setting,
      externalDatabaseId: externalDbUuid,
      selectedPrimaryKey: selectedPrimaryKey ? selectedPrimaryKey : 'id',
      name: name ? name : '',
    };

    await actions.createCollectionWithDirectus(data);
    await actions.updateExternalDatabaseForDirectus({
      projectId,
      externalDbUuid,
      newResult,
      version,
      collectionName: selectedData.name,
      collectionTitle: values.collectionTitle,
      selectedPrimaryKey: selectedPrimaryKey ? selectedPrimaryKey : 'id',
    });
    this.handleCollection();
  };

  handleFieldChange = (fieldName, selectedValue) => {
    const updatedResult = { ...this.state.fieldDatatypes };
    updatedResult[fieldName[0]] = selectedValue;
    this.setState({ fieldDatatypes: updatedResult });
  };
  handleRadioChange = (fieldName) => {
    this.setState({ selectedPrimaryKey: fieldName }, () => {});
  };
  showAlertMessage = () => {
    return (
      <AlertMessageBox
        type="info"
        text={`Note: If no primary key is selected below, the system will default to using the 
<strong>'id'</strong> field as the primary key for External APIs.`}
      />
    );
  };

  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />;
        </CommonPageComponent>
      );
    }
    const {
      loadExternalDatabaseForDirectusPending,
      getSchemaForDirectusCollectionPending,
      createCollectionWithDirectusPending,
      updateExternalDatabaseForDirectusPending,
      externalDbDirectus,
    } = this.props.dataConnector;
    const { completeData } = externalDbDirectus ? externalDbDirectus : '';
    const selectedCollection = completeData
      ? completeData['tables'][this.state.selectedCollectionIndex]
      : null;
    const fieldData = selectedCollection ? selectedCollection.fields : null;
    if (loadExternalDatabaseForDirectusPending || getSchemaForDirectusCollectionPending) {
      return (
        <CommonPageComponent>
          <div className="text-center">
            <CustomLoader
              loading={
                loadExternalDatabaseForDirectusPending || getSchemaForDirectusCollectionPending
              }
              size="20px"
              color="#303453"
            />
          </div>
        </CommonPageComponent>
      );
    }
    return fieldData ? (
      <CommonPageComponent>
        <ParentContentCard
          title={'Choose Collection for Create Or Skip via Directus'}
          icon={'collection'}
        >
          <Formik
            initialValues={{ collectionTitle: selectedCollection.name }}
            enableReinitialize={true}
          >
            {({ values, handleChange, setFieldValue }) => (
              <Form className="ml-5">
                <div className="col-md-11 col-lg-11 col-sm-12 col-xs-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Name"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Directus collection name'}
                    >
                      <Field
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Collection Name"
                        readOnly
                        value={selectedCollection.name}
                      />
                    </FormFieldWithLabel>
                  </div>

                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Title"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Enter name for the collection name if  you want to change'}
                    >
                      <Field
                        type="text"
                        name="collectionTitle"
                        className="form-control form-control-sm"
                        placeholder="Collection Title"
                        value={values.collectionTitle}
                        onChange={(e) => setFieldValue('collectionTitle', e.target.value)}
                      />
                      <ErrorMessage name="collectionTitle" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>
                  <hr style={{ marginBottom: '20px', visibility: 'hidden' }} />
                  {this.showAlertMessage()}
                  <div className="mt-2">
                    <h5>
                      <b>Field Type Mapping</b>
                    </h5>
                  </div>
                  <div
                    className="table-responsive"
                    style={{
                      overflow: 'visible',
                      maxHeight: 'fit-content',
                      marginBottom: '10px',
                    }}
                  >
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Fields</th>
                          <th>Types</th>
                          <th style={{ width: '12%' }}>Primary Key</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.keys(fieldData).map((fieldName, index) => (
                          <tr key={index}>
                            <td>{fieldName}</td>
                            <td>
                              <CustomSelect
                                name={fieldName}
                                isMulti={false}
                                onChange={setFieldValue}
                                onChangeValue={this.handleFieldChange}
                                options={dropdownsForSource}
                                value={getFieldDataTypeValue(
                                  fieldName,
                                  fieldData,
                                  this.state.fieldDatatypes,
                                )}
                              />
                            </td>
                            <td style={{ width: '12%' }}>
                              <div className="form-check ml-4 pl-3">
                                <CustomRadio label="" isRadio={false}>
                                  <Field
                                    type="checkbox"
                                    name={fieldName}
                                    className="form-check-input"
                                    checked={this.state.selectedPrimaryKey === fieldName}
                                    onChange={() => this.handleRadioChange(fieldName)}
                                  />
                                </CustomRadio>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-between">
                    <button
                      className="btn btn-outline-secondary btn-md"
                      title="Skip"
                      type="button"
                      onClick={this.handleCollection}
                    >
                      <i className="wb webconnect-times"></i> Skip & Continue
                    </button>
                    <button
                      type="button"
                      className="btn btn-theme-submit btn-md ml-3"
                      title="Save Collection"
                      onClick={() => this.handleSave(values)}
                      disabled={
                        createCollectionWithDirectusPending ||
                        updateExternalDatabaseForDirectusPending
                      }
                    >
                      <i className="wb webconnect-save-regular"></i> Save & Continue
                      <CustomLoader
                        loading={
                          createCollectionWithDirectusPending ||
                          updateExternalDatabaseForDirectusPending
                        }
                      />
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    ) : (
      <CommonPageComponent>
        <ParentContentCard
          title={'Choose Collection for Create Or Skip via Directus'}
          icon={'collection'}
        >
          <Formik
            initialValues={{ collectionTitle: selectedCollection && selectedCollection.name }}
            enableReinitialize={true}
          >
            {({ values, handleChange, setFieldValue }) => (
              <Form className="ml-5">
                <div className="col-md-11 col-lg-11 col-sm-12 col-xs-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Name"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Directus collection name'}
                    >
                      <Field
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Collection Name"
                        readOnly
                        value={selectedCollection && selectedCollection.name}
                      />
                    </FormFieldWithLabel>
                  </div>

                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Title"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Enter name for the collection name if  you want to change'}
                    >
                      <Field
                        type="text"
                        name="collectionTitle"
                        className="form-control form-control-sm"
                        placeholder="Collection Title"
                        value={values.collectionTitle}
                        onChange={(e) => setFieldValue('collectionTitle', e.target.value)}
                      />
                      <ErrorMessage name="collectionTitle" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>
                  <hr style={{ marginBottom: '20px', visibility: 'hidden' }} />
                  <div className="mt-2">
                    <h5>
                      <b>Field Type Mapping</b>
                    </h5>
                  </div>
                  <div className="mt-2 text-center">
                    <h5>Not Fields Added Yet !</h5>
                  </div>
                  <div className="float-left">
                    <button
                      className="btn btn-outline-secondary btn-md float-left"
                      title="Skip"
                      type="button"
                      onClick={this.handleCollection}
                    >
                      <i className="wb webconnect-times"></i> Skip & Continue
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DirectusCollectionsCreate);
